const AN_ERROR_OCCURRED = 'Sorry, we cannot process the request. Try Later';

export default AN_ERROR_OCCURRED;
